"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.TITLES = exports.STATUSES = exports.EXTRA_STATUSES = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _isAfter = _interopRequireDefault(require("date-fns/isAfter"));
var _fromUnixTime = _interopRequireDefault(require("date-fns/fromUnixTime"));
var _Bubble = _interopRequireDefault(require("../../../Bubble"));
var _date = require("../../../../utils/date");
var _TimeFrom = _interopRequireDefault(require("../../Common/TimeFrom"));
var _iconsReact = require("../../../../icons-react");
var _constants = require("../../../../constants");
var _constants2 = require("./constants");
var _excluded = ["priority", "time", "type", "title", "isOption", "planReason", "closeReason", "orderIds", "className", "placement"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var STATUSES = exports.STATUSES = {
  OPEN: 'open',
  WAIT_FOR_CLIENT: 'wait_for_client',
  WAIT_FOR_OPERATOR: 'wait_for_operator',
  WAIT_FOR_SERVICE: 'wait_for_service',
  CLOSED: 'closed',
  PLANNED: 'planned'
};
var EXTRA_STATUSES = exports.EXTRA_STATUSES = {
  CLOSED_BY_ORDER: 'closed_by_order',
  CLOSED_BY_REASON: 'closed_by_reason',
  CLOSE_ACTION: 'close_action'
};
var TITLES = exports.TITLES = (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])({}, STATUSES.CLOSED, 'Закрыт'), STATUSES.OPEN, 'Неразобранное'), STATUSES.PLANNED, 'Запланировано'), STATUSES.WAIT_FOR_CLIENT, 'Ожидаем ответа туриста'), STATUSES.WAIT_FOR_OPERATOR, 'Ожидает ответа от ТО'), STATUSES.WAIT_FOR_SERVICE, 'Требуется действие'), EXTRA_STATUSES.CLOSED_BY_ORDER, 'Подобран'), EXTRA_STATUSES.CLOSED_BY_REASON, 'Не подобран'), EXTRA_STATUSES.CLOSE_ACTION, 'Закрыть тикет');
var PRIORITIES_BY_STATUS = (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])({}, STATUSES.CLOSED, _constants2.PRIORITIES.LOW), STATUSES.OPEN, _constants2.PRIORITIES.MEDIUM), STATUSES.WAIT_FOR_CLIENT, _constants2.PRIORITIES.MEDIUM), STATUSES.WAIT_FOR_OPERATOR, _constants2.PRIORITIES.MEDIUM), STATUSES.WAIT_FOR_SERVICE, _constants2.PRIORITIES.HIGH), STATUSES.PLANNED, _constants2.PRIORITIES.MEDIUM);
var TIME_FORMAT = 'd MMM H:mm';
var TicketStatus = /*#__PURE__*/_react["default"].memo(function (_ref) {
  var priority = _ref.priority,
    time = _ref.time,
    type = _ref.type,
    serverTitle = _ref.title,
    isOption = _ref.isOption,
    planReason = _ref.planReason,
    closeReason = _ref.closeReason,
    orderIds = _ref.orderIds,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    placement = _ref.placement,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var today = new Date();
  var statusTime = (0, _fromUnixTime["default"])(time);
  var titleLabel = TITLES[serverTitle] ? TITLES[serverTitle] : TITLES[STATUSES.OPEN];
  var isDisabledBubble = placement !== _constants2.TICKET_STATUS_PLACEMENT.TICKET_CARD && placement !== _constants2.TICKET_STATUS_PLACEMENT.TICKET_CARD_WITH_MANAGER;
  var icon = /*#__PURE__*/_react["default"].createElement(StyledIcon, {
    serverTitle: serverTitle,
    priority: priority
  });
  if (serverTitle === STATUSES.CLOSED) {
    titleLabel = isOption ? TITLES[EXTRA_STATUSES.CLOSE_ACTION] : TITLES[STATUSES.CLOSED];
    if (type === _constants.TICKET_TYPES.TOUR_SELECTION) {
      if (!(0, _isEmpty2["default"])(orderIds)) {
        titleLabel = /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, TITLES[EXTRA_STATUSES.CLOSED_BY_ORDER], /*#__PURE__*/_react["default"].createElement(StyledHighlightGreen, null, "\u2116", orderIds.join(', ')));
      }
      if (closeReason) {
        titleLabel = /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, TITLES[EXTRA_STATUSES.CLOSED_BY_REASON], /*#__PURE__*/_react["default"].createElement(StyledHighlightRed, null, closeReason.label));
      }
    }
    icon = /*#__PURE__*/_react["default"].createElement(StyledExplosionIcon, {
      isOption: isOption
    });
  }
  if (serverTitle === STATUSES.PLANNED) {
    titleLabel = (planReason === null || planReason === void 0 ? void 0 : planReason.title) || TITLES[STATUSES.PLANNED];
  }
  if (serverTitle === STATUSES.WAIT_FOR_SERVICE) {
    titleLabel = (planReason === null || planReason === void 0 ? void 0 : planReason.id) && (planReason === null || planReason === void 0 ? void 0 : planReason.title) || TITLES[STATUSES.WAIT_FOR_SERVICE];
  }
  var isShownTime = time && (serverTitle === STATUSES.CLOSED || serverTitle === STATUSES.PLANNED);
  return /*#__PURE__*/_react["default"].createElement(_Bubble["default"], {
    text: "\u041F\u0440\u0438\u043E\u0440\u0438\u0442\u0435\u0442 \u0442\u0438\u043A\u0435\u0442\u0430: ".concat(_constants2.TRANSLATE_PRIORITIES[priority]),
    placement: "bottom",
    disabled: true,
    alt: "\u041F\u0440\u0438\u043E\u0440\u0438\u0442\u0435\u0442 \u0442\u0438\u043A\u0435\u0442\u0430: ".concat(_constants2.TRANSLATE_PRIORITIES[priority]),
    shouldStopPropagation: false
  }, /*#__PURE__*/_react["default"].createElement(StyledTicketStatus, (0, _extends2["default"])({
    className: className
  }, props), icon, /*#__PURE__*/_react["default"].createElement(StyledTitle, {
    title: titleLabel
  }, titleLabel), isShownTime && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, (0, _isAfter["default"])(statusTime, today) ? /*#__PURE__*/_react["default"].createElement(StyledTime, null, (0, _date.formatDate)(statusTime, TIME_FORMAT)) : /*#__PURE__*/_react["default"].createElement(StyledTimeFrom, {
    time: time
  }))));
});
TicketStatus.displayName = 'TicketStatus';
TicketStatus.propTypes = {
  className: _propTypes["default"].string,
  priority: _propTypes["default"].oneOf(Object.values(_constants2.PRIORITIES)),
  time: _propTypes["default"].number,
  title: _propTypes["default"].string.isRequired,
  isOption: _propTypes["default"].bool,
  orderIds: _propTypes["default"].arrayOf(_propTypes["default"].string),
  closeReason: _propTypes["default"].shape({
    label: _propTypes["default"].string,
    value: _propTypes["default"].string
  }),
  planReason: _propTypes["default"].shape({
    label: _propTypes["default"].string,
    value: _propTypes["default"].string
  }),
  type: _propTypes["default"].oneOf(Object.values(_constants.TICKET_TYPES)),
  placement: _propTypes["default"].oneOf(Object.values(_constants2.TICKET_STATUS_PLACEMENT))
};
TicketStatus.defaultProps = {
  className: '',
  priority: _constants2.PRIORITIES.MEDIUM,
  time: null,
  isOption: false,
  orderIds: null,
  closeReason: null,
  planReason: null,
  type: _constants.TICKET_TYPES.UNKNOWN
};
var StyledTicketStatus = _styledComponents["default"].div.withConfig({
  displayName: "TicketStatus__StyledTicketStatus",
  componentId: "sc-ltq0aj-0"
})(["align-items:center;display:flex;font-size:14px;overflow:hidden;> * + *{margin-left:6px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;}"]);
var flicker = (0, _styledComponents.keyframes)(["0%{background-color:", ";}100%{background-color:transparent;}"], _constants2.COLORS_BY_PRIORITY[_constants2.PRIORITIES.CRITICAL]);
var StyledIcon = _styledComponents["default"].div.withConfig({
  displayName: "TicketStatus__StyledIcon",
  componentId: "sc-ltq0aj-1"
})(["align-self:center;border-radius:50%;flex-shrink:0;height:6px;width:6px;margin:1px 5px 0;", " ", ""], function (_ref2) {
  var priority = _ref2.priority;
  return "background-color: ".concat(_constants2.COLORS_BY_PRIORITY[priority], ";");
}, function (_ref3) {
  var priority = _ref3.priority;
  return priority === _constants2.PRIORITIES.CRITICAL && (0, _styledComponents.css)(["animation:", " 1s linear infinite alternate;"], flicker);
});
var StyledExplosionIcon = (0, _styledComponents["default"])(_iconsReact.Explosion).withConfig({
  displayName: "TicketStatus__StyledExplosionIcon",
  componentId: "sc-ltq0aj-2"
})(["width:16px;height:17px;path{fill:", ";}"], function (props) {
  return props.isOption ? '#D0021B' : '#919499';
});
var StyledTitle = _styledComponents["default"].span.withConfig({
  displayName: "TicketStatus__StyledTitle",
  componentId: "sc-ltq0aj-3"
})([""]);
var StyledHighlightGreen = _styledComponents["default"].span.withConfig({
  displayName: "TicketStatus__StyledHighlightGreen",
  componentId: "sc-ltq0aj-4"
})(["color:#00c253;font-size:12px;margin-left:5px;"]);
var StyledHighlightRed = _styledComponents["default"].span.withConfig({
  displayName: "TicketStatus__StyledHighlightRed",
  componentId: "sc-ltq0aj-5"
})(["color:#d0021b;font-size:12px;margin-left:5px;"]);
var StyledTimeFrom = (0, _styledComponents["default"])(_TimeFrom["default"]).withConfig({
  displayName: "TicketStatus__StyledTimeFrom",
  componentId: "sc-ltq0aj-6"
})(["color:#4d4d4d;"]);
var StyledTime = _styledComponents["default"].span.withConfig({
  displayName: "TicketStatus__StyledTime",
  componentId: "sc-ltq0aj-7"
})(["color:#4d4d4d;cursor:default;font-size:11px;"]);
TicketStatus.TITLES = TITLES;
TicketStatus.EXTRA_STATUSES = EXTRA_STATUSES;
TicketStatus.PRIORITIES = _constants2.PRIORITIES;
TicketStatus.STATUSES = STATUSES;
TicketStatus.PRIORITIES_BY_STATUS = PRIORITIES_BY_STATUS;
TicketStatus.StyledIcon = StyledIcon;
TicketStatus.StyledTimeFrom = StyledTimeFrom;
TicketStatus.StyledTitle = StyledTitle;
var _default = exports["default"] = TicketStatus;